import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { scopeActions } from "../actions";
import api from "../services/scope.service";
import { generalActions } from "../actions";
import ACTIONS from "../constants";
import { scopePagination, taskPagination } from "../selectors/scope.selector";
import { calculatePageSize } from "../../helpers/utils";
import { getProjectProgressSummary } from "../actions/projects.actions";
import { getPortFolioProgressSummary } from "../actions/portfolio.actions";
import { getProgramProgressSummary } from "../actions/programs.actions";

function* getScope(state) {
  try {
    yield put(scopeActions.getScopeAttempt.pending);
    const scopeItems = yield call(api.scopeRequest, state.payload);
    const pagination = JSON.parse(scopeItems.headers["x-pagination"]);
    const data = {
      data: scopeItems.data,
      pagination: pagination,
    };
    yield put(scopeActions.getScopeAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(scopeActions.getScopeAttempt.error(""));
    } else {
      yield put(scopeActions.getScopeAttempt.error(error.message));
    }
  }
}

function* getMilestones(state) {
  try {
    yield put(scopeActions.getScopeAttempt.pending);
    const milestoneItems = yield call(api.milestonesRequest, state.payload);
    const pagination = JSON.parse(milestoneItems.headers["x-pagination"]);
    const data = {
      data: milestoneItems.data,
      pagination: pagination,
    };
    yield put(scopeActions.getScopeAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(scopeActions.getScopeAttempt.error(""));
    } else {
      yield put(scopeActions.getScopeAttempt.error(error.message));
    }
  }
}

function* createScope(state) {
  try {
    yield put(scopeActions.createScopeAttempt.pending);
    yield call(api.createScopeRequest, state.payload.payload);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: 1,
      size: calculatePageSize(),
    };
    let results;
    if (state.payload.isMilestone) {
      results = yield call(api.milestonesRequest, payload);
    } else {
      results = yield call(api.scopeRequest, payload);
    }
    if (state.payload.parent == "Project") {
      yield put(getProjectProgressSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioProgressSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramProgressSummary({ id: state.payload.parentID }));
    }
    const pagination = JSON.parse(results.headers["x-pagination"]);
    const data = {
      data: results.data,
      pagination: pagination,
    };
    yield put(scopeActions.createScopeAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: `${state.payload.isMilestone ? "Milestone" : "Scope Item"
          }  created successfully`,
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(scopeActions.createScopeAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(scopeActions.createScopeAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(scopeActions.createScopeAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateScope(state) {
  try {
    yield put(scopeActions.updateScopeAttempt.pending);
    yield call(api.updateScopeRequest, {
      id: state.payload.sId,
      payload: state.payload.payload,
    });
    if (state.payload.parent == "Project") {
      yield put(getProjectProgressSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioProgressSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramProgressSummary({ id: state.payload.parentID }));
    }
    const paginat = yield select(scopePagination);

    let scopes;
    if (state.payload.type === "overview") {
      scopes = yield call(api.getScopeDetailsRequest, {
        id: state.payload.sId,
      });
      const data = {
        type: state.payload.type,
        data: scopes,
      };
      yield put(scopeActions.updateScopeAttempt.success(data));
      yield put(
        generalActions.showToast({
          title: "Scope updated successfully",
          type: "success",
        })
      );
    } else {
      const payload = {
        id: state.payload.parentID,
        parent: state.payload.parent,
        page: paginat.CurrentPage,
        size: paginat.PageSize,
      };
      if (state.payload.isMilestone) {
        scopes = yield call(api.milestonesRequest, payload);
      } else {
        scopes = yield call(api.scopeRequest, payload);
      }
      const pagination = JSON.parse(scopes.headers["x-pagination"]);
      const data = {
        data: scopes.data,
        pagination: pagination,
      };
      yield put(scopeActions.updateScopeAttempt.success(data));
      yield put(
        generalActions.showToast({
          title: `${state.payload.isMilestone ? "Milestone" : "Scope Item"
            } updated successfully`,
          type: "success",
        })
      );
    }
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(scopeActions.updateScopeAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(scopeActions.updateScopeAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(scopeActions.updateScopeAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteScope(state) {
  try {
    yield put(scopeActions.deleteScopeAttempt.pending);
    yield call(api.deleteScopeRequest, state.payload.sId);
    if (state.payload.parent == "Project") {
      yield put(getProjectProgressSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioProgressSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramProgressSummary({ id: state.payload.parentID }));
    }
    const paginat = yield select(scopePagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    // const payload = {id:state.payload.id, page: paginat.CurrentPage, size: paginat.PageSize}
    let results;
    if (state.payload.isMilestone) {
      results = yield call(api.milestonesRequest, payload);
    } else {
      results = yield call(api.scopeRequest, payload);
    }
    const pagination = JSON.parse(results.headers["x-pagination"]);
    const data = {
      data: results.data,
      pagination: pagination,
    };
    yield put(scopeActions.deleteScopeAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Deleted successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(scopeActions.deleteScopeAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(scopeActions.deleteScopeAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(scopeActions.deleteScopeAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* duplicateScope(state) {
  try {
    yield put(scopeActions.duplicateScopeAttempt.pending);
    yield call(api.duplicateScopeRequest, state.payload);
    yield put(scopeActions.duplicateScopeAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Scope Duplicated successfully",
        type: "success",
      })
    );

    if (state.payload.callback) {
      state.payload.callback();
    }

  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(scopeActions.deleteScopeAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(scopeActions.deleteScopeAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(scopeActions.deleteScopeAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* duplicateTask(state) {
  try {
    yield put(scopeActions.duplicateTaskAttempt.pending);
    yield call(api.duplicateTaskRequest, state.payload);
    yield put(scopeActions.duplicateTaskAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Task Duplicated successfully",
        type: "success",
      })
    );

    if (state.payload.callback) {
      state.payload.callback();
    }

  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(scopeActions.deleteScopeAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(scopeActions.deleteScopeAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(scopeActions.deleteScopeAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateScopeFlag(state) {
  try {
    yield put(scopeActions.updateScopeFlagAttempt.pending);
    yield call(api.updateScopeFlagRequest, state.payload);
    yield put(
      generalActions.showToast({
        title: "Scope flag updated successfully",
        type: "success",
      })
    );
    yield put(scopeActions.updateScopeFlagAttempt.success());
  } catch (error) {
    yield put(scopeActions.updateScopeFlagAttempt.error(error.message));
  }
}

function* getScopeProgressSummary(state) {
  try {
    yield put(scopeActions.getScopeProgressSummaryAttempt.pending);
    const progressSummary = yield call(api.getScopeProgressSummaryRequest, state.payload);
    yield put(scopeActions.getScopeProgressSummaryAttempt.success(progressSummary));
  } catch (error) {
    yield put(scopeActions.getScopeProgressSummaryAttempt.error(error.message));
  }
}

function* getScopeItemDetails(state) {
  try {
    yield put(scopeActions.getScopeDetailsAttempt.pending);
    const scopeItem = yield call(api.getScopeDetailsRequest, state.payload);
    yield put(scopeActions.getScopeDetailsAttempt.success(scopeItem));
  } catch (error) {
    yield put(scopeActions.getScopeDetailsAttempt.error(error.message));
  }
}

function* sortScopeItems(state) {
  try {
    yield put(scopeActions.sortScopeItemsRequestAttempt.pending);
    const scopeItems = yield call(api.sortScopeItemsRequest, state.payload);
    const pagination = JSON.parse(scopeItems.headers["x-pagination"]);
    const data = {
      data: scopeItems.data,
      pagination: pagination,
    };
    yield put(scopeActions.sortScopeItemsRequestAttempt.success(data));
  } catch (error) {
    yield put(scopeActions.sortScopeItemsRequestAttempt.error(error));
  }
}

function* getTask(state) {
  try {
    yield put(scopeActions.getTaskAttempt.pending);
    const tasks = yield call(api.taskRequest, state.payload);
    const pagination = JSON.parse(tasks.headers["x-pagination"]);
    const data = {
      data: tasks.data,
      pagination: pagination,
    };
    yield put(scopeActions.getTaskAttempt.success(data));
  } catch (error) {
    yield put(scopeActions.getTaskAttempt.error(error.message));
  }
}

function* createTask(state) {
  try {
    yield put(scopeActions.createTaskAttempt.pending);
    yield call(api.createTaskRequest, state.payload.payload);
    const payload = {
      id: state.payload.id,
      parent: state.payload.parent,
      page: 1,
      size: 20,
    };
    if (state.payload.parent == "Project") {
      yield put(getProjectProgressSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioProgressSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramProgressSummary({ id: state.payload.parentID }));
    }
    const task = yield call(api.taskRequest, payload);
    const data = {
      data: task.data,
      pagination: {
        CurrentPage: 1,
        TotalPages: 1,
        PageSize: 20,
        TotalCount: task.data.length,
        HasPrevious: false,
        HasNext: false,
      },
    };
    yield put(scopeActions.createTaskAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Task created successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (errorObject.status === 500) {
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(scopeActions.createTaskAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateTask(state) {
  try {
    yield put(scopeActions.updateTaskAttempt.pending);
    yield call(api.updateTaskRequest, {
      id: state.payload.tId,
      payload: state.payload.payload,
    });
    const paginat = yield select(taskPagination);
    const payload = {
      parent: state.payload.parent,
      id: state.payload.id,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const task = yield call(api.taskRequest, payload);
    const pagination = JSON.parse(task.headers["x-pagination"]);
    const data = {
      data: task.data,
      pagination: pagination,
    };
    yield put(scopeActions.updateTaskAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Task updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (errorObject.status === 500) {
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(scopeActions.updateTaskAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateTaskStatus(state) {
  try {
    yield put(scopeActions.updateTaskStatusAttempt.pending);
    yield call(api.updateTaskStatusRequest, {
      id: state.payload.tId,
      payload: state.payload.payload,
    });
    const paginat = yield select(taskPagination);
    const payload = {
      parent: state.payload.parent,
      id: state.payload.id,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const task = yield call(api.taskRequest, payload);
    const pagination = JSON.parse(task.headers["x-pagination"]);
    const data = {
      data: task.data,
      pagination: pagination,
    };
    yield put(scopeActions.updateTaskStatusAttempt.success(data));
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (errorObject.status === 500) {
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(scopeActions.updateTaskStatusAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteTask(state) {
  try {
    yield put(scopeActions.deleteTaskAttempt.pending);
    yield call(api.deleteTaskRequest, { id: state.payload.tId });
    const paginat = yield select(taskPagination);
    const payload = {
      parent: state.payload.parent,
      id: state.payload.id,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const tasks = yield call(api.taskRequest, payload);
    const pagination = JSON.parse(tasks.headers["x-pagination"]);
    const data = {
      data: tasks.data,
      pagination: pagination,
    };
    yield put(scopeActions.deleteTaskAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Deleted successfully",
        type: "success",
      })
    );

    if (state.payload.callback) {
      state.payload.callback();
    }
  } catch (error) {
    yield put(scopeActions.deleteTaskAttempt.error(error.message));
  }
}

function* sortTasks(state) {
  try {
    yield put(scopeActions.sortTasksRequestAttempt.pending);
    const task = yield call(api.sortTasksRequest, state.payload);
    const pagination = JSON.parse(task.headers["x-pagination"]);
    const data = {
      data: task.data,
      pagination: pagination,
    };
    yield put(scopeActions.sortTasksRequestAttempt.success(data));
  } catch (error) {
    yield put(scopeActions.sortTasksRequestAttempt.error(error));
  }
}

function* getResourcesShifts(state) {
  try {
    yield put(scopeActions.resourcesShifts.pending);
    const shifts = yield call(api.resourceShiftsRequest, state.payload);
    yield put(scopeActions.resourcesShifts.success(shifts));
  } catch (error) {
    yield put(scopeActions.resourcesShifts.error(error.message));
  }
}

function* updateTaskFlag(state) {
  try {
    yield put(scopeActions.updateTaskFlagAttempt.pending);
    yield call(api.updateTaskFlagRequest, state.payload);
    yield put(scopeActions.updateTaskFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Task flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(scopeActions.updateTaskFlagAttempt.error(error.message));
  }
}

function* getResourcesMonitor(state) {
  try {
    yield put(scopeActions.resourcesMonitor.pending);
    const resources = yield call(api.resourcesMonitorRequest, state.payload);
    yield put(scopeActions.resourcesMonitor.success(resources));
  } catch (error) {
    yield put(scopeActions.resourcesMonitor.error(error.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.SCOPE_CALL, getScope),
    takeEvery(ACTIONS.CREATE_SCOPE_CALL, createScope),
    takeEvery(ACTIONS.UPDATE_SCOPE_CALL, updateScope),
    takeEvery(ACTIONS.DELETE_SCOPE_CALL, deleteScope),
    takeEvery(ACTIONS.DUPLICATE_SCOPE_CALL, duplicateScope),
    takeEvery(ACTIONS.DUPLICATE_TASK_CALL, duplicateTask),
    takeEvery(ACTIONS.SCOPE_FLAG_CALL, updateScopeFlag),
    takeEvery(ACTIONS.GET_SCOPE_PROGRESS_SUMMARY_CALL, getScopeProgressSummary),
    takeEvery(ACTIONS.SCOPE_DETAILS_CALL, getScopeItemDetails),
    takeEvery(ACTIONS.SORT_SCOPEITEMS_CALL, sortScopeItems),
    takeEvery(ACTIONS.TASK_CALL, getTask),
    takeEvery(ACTIONS.CREATE_TASK_CALL, createTask),
    takeEvery(ACTIONS.UPDATE_TASK_CALL, updateTask),
    takeEvery(ACTIONS.UPDATE_TASK_STATUS_CALL, updateTaskStatus),
    takeEvery(ACTIONS.DELETE_TASK_CALL, deleteTask),
    takeEvery(ACTIONS.SORT_TASKS_CALL, sortTasks),
    takeEvery(ACTIONS.TASK_FLAG_CALL, updateTaskFlag),
    takeEvery(ACTIONS.RESOURCE_SHIFTS_CALL, getResourcesShifts),
    takeEvery(ACTIONS.RESOURCE_MONITOR_CALL, getResourcesMonitor),
  ]);
}
